import { ModalPageProps } from "components/ModalPageClients/types";
import { EquipmentDTO } from "dtos/PmocEnvironmentDTO";
import { useEnvironment } from "hooks/pmoc/environmentPmoc";
import React, { useEffect, useState } from "react";
import { EnvironmentPageProps } from "../EnvironmentFlow/types";

import { FiChevronLeft } from "react-icons/fi";

//import QRCodeIcon from 'assets/icons/pmoc/qrCodeBorder.svg';

import * as S from "./styles";
import { useToast } from "hooks/toast";
import { useTheme } from "styled-components";
import { api } from "services/api";
import { Dropdown, DropdownOption } from "components/DropDown";
import { Input } from "components/Input";
import { ToogleButton } from "components/ToogleButton";
import { Button } from "components/Button";

import * as Yup from "yup";
import getValidationErrors from "utils/getValidationErrors";
import axios from "axios";

import { LoadingProfiz } from "components/LoadingProfiz";
import { InputAddNewCategory } from "components/InputAddNewCategory";
import { DisabledDropDown } from "components/DisabledDropDown";
import { AlertModal } from "components/AlertModal";
import { ShowWhenHavePermission } from "components/Permission";

type EquipmentTypeProps = {
  id: number;
  name: string;
  default?: string | undefined;
};

type CapabilitiesProps = {
  id: number;
  name: string;
  default?: string | undefined;
};

type EquipmentProps = {
  id: number;
  name: string;
  default: boolean;
  types: EquipmentTypeProps[];
  capabilities: CapabilitiesProps[];
};

type CategoryProps = {
  equipments: EquipmentProps[];
} & CapabilitiesProps;

type EquipmentSubProps = {
  id: number;
  name: string;
  default: boolean;
  types: EquipmentTypeProps[];
  capacities: CapabilitiesProps[];
};

type Errors = {
  [key: string]: string;
};

type PageProps = {
  handleChooseEditModal?: ModalPageProps;
  handleChooseEnvironment?: EnvironmentPageProps;
};

export function EditEquipment({
  handleChooseEnvironment,
  handleChooseEditModal,
}: PageProps) {
  const { addToast } = useToast();
  const theme = useTheme();

  const { environment, userIdPMOC, equipment, unityIdPMOC, nameFlow } =
    useEnvironment();

  const [brand, setBrand] = useState("");
  const [model, setModel] = useState("");
  const [tagEquipment, setTagEquipment] = useState("");
  const [componentName, setComponentName] = useState("");
  const [isComponentName, setIsComponentName] = useState(false);
  const [categoryProps, setCategoryProps] = useState<DropdownOption[]>([]);

  const [showAlertDelete, setShowAlertDelete] = useState(false);

  //const [typeTagEquipment, setTypeTagEquipment] = useState(1);

  const [equipmentsData, setEquipmentsData] = useState<DropdownOption[]>([]);
  const [capacitiesProps, setCapacitiesProps] = useState<DropdownOption[]>([]);
  const [equipmentTypeProps, setEquipmentTypeProps] = useState<
    DropdownOption[]
  >([]);

  const [categoryIdDropdown, setCategoryIdDropdown] = useState<DropdownOption>(
    {} as DropdownOption
  );

  const [equipmentIdDropdown, setEquipmentIdDropdown] =
    useState<DropdownOption>({} as DropdownOption);
  const [equipmentTypeIdDropdown, setEquipmentTypeIdDropdown] =
    useState<DropdownOption>({} as DropdownOption);
  const [capacityIdDropdown, setCapacityIdDropdown] = useState<DropdownOption>(
    {} as DropdownOption
  );
  const [hasError, setHasError] = useState<Errors>({} as Errors);

  const [categoryTree, setCategoryTree] = useState<CategoryProps[]>([]);
  const [equipmentSubTree, setEquipmentSubTree] = useState<EquipmentSubProps[]>(
    []
  );

  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingInfo, setLoadingInfo] = useState(false);

  const [loadingInputButton, setLoadingInputButton] = useState(false);
  const [newEquipmentType, setNewEquipmentType] = useState("");
  const [newCapacity, setNewCapacity] = useState("");
  const [newEquipment, setNewEquipment] = useState("");

  useEffect(() => {
    setEqtInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function setEqtInfo() {
    try {
      setLoadingInfo(true);

      const response = await api.get("pmoc/equipment/items");

      setCategoryTree(response.data.categoryTree);

      const categoryInfo = response.data.categoryTree.map(
        (element: CategoryProps) => {
          return {
            id: Number(element.id),
            name: element.name,
          };
        }
      );
      setCategoryProps(categoryInfo);
      const eqtList = response.data.categoryTree.find(
        (element: EquipmentProps) =>
          Number(element.id) === Number(equipment.category.id)
      ).equipments;

      setEquipmentsData(
        eqtList.map((eqt: EquipmentProps) => {
          return {
            ...eqt,
            id: Number(eqt.id),
          };
        })
      );

      const eqtoInfo = eqtList.find(
        (element: EquipmentProps) =>
          Number(element.id) === Number(equipment.equipment.id)
      );

      eqtoInfo &&
        setEquipmentTypeProps(
          eqtoInfo.types.map((typeEqto: EquipmentTypeProps) => {
            return {
              ...typeEqto,
              id: Number(typeEqto.id),
            };
          })
        );
      eqtoInfo &&
        setCapacitiesProps(
          eqtoInfo.capabilities.map((capabilityEqto: CapabilitiesProps) => {
            return {
              ...capabilityEqto,
              id: Number(capabilityEqto.id),
            };
          })
        );

      if (equipment && Object.keys(equipment).length > 0) {
        equipment.category &&
          setCategoryIdDropdown({
            id: equipment.category.id,
            name: equipment.category.name,
          });
        equipment.equipment &&
          setEquipmentIdDropdown({
            id: equipment.equipment.id,
            name: equipment.equipment.name,
          });

        equipment.equipmentType &&
          setEquipmentTypeIdDropdown({
            id: equipment.equipmentType.id,
            name: equipment.equipmentType.name,
          });

        equipment.capacity &&
          setCapacityIdDropdown({
            id: equipment.capacity.id,
            name: equipment.capacity.name,
          });

        equipment.brand && setBrand(equipment.brand);
        equipment.model && setModel(equipment.model);
        equipment.tagEquipment && setTagEquipment(equipment.tagEquipment);
        equipment.componentName && setComponentName(equipment.componentName);
        equipment.componentName && setIsComponentName(true);
      }
    } catch (error) {
      addToast({
        title: "Erro",
        description:
          axios.isAxiosError(error) && error.response?.data.error
            ? error.response.data.error
            : "Não foi possível carregar as informações.",
        type: "error",
      });
    } finally {
      setLoadingInfo(false);
    }
  }

  function handleBackButton() {
    if (nameFlow === "unity" && handleChooseEditModal) {
      return handleChooseEditModal("detailEquipment");
    }
    handleChooseEnvironment && handleChooseEnvironment("detailEquipment");
  }

  function handleSelectedCategory(category: DropdownOption) {
    if (categoryIdDropdown && categoryIdDropdown.id === category.id) return;

    setCategoryIdDropdown(category);

    setEquipmentIdDropdown({} as DropdownOption);
    setEquipmentTypeIdDropdown({} as DropdownOption);
    setCapacityIdDropdown({} as DropdownOption);

    let catInfo: CategoryProps =
      categoryTree.find(
        (element: CategoryProps) => Number(element.id) === Number(category.id)
      ) || ({} as CategoryProps);

    if (Object.keys(catInfo).length > 0) {
      let catInfoFormatted = JSON.parse(JSON.stringify(catInfo.equipments)).map(
        (eqt: EquipmentProps) => {
          return {
            ...eqt,
            capacities: eqt.capabilities,
          };
        }
      );
      setEquipmentSubTree(catInfoFormatted);
    }
    if (catInfo && catInfo.equipments) {
      let aux = JSON.parse(
        JSON.stringify(catInfo.equipments)
      ) as DropdownOption[];
      setEquipmentsData(aux);
    }
    setHasError((errors) => ({
      ...errors,
      hasErrorOnCategory: "",
    }));
  }

  function handleSelectedEquipment(equipmentOption: DropdownOption) {
    if (equipmentIdDropdown && equipmentIdDropdown.id === equipmentOption.id) {
      return;
    }

    setEquipmentIdDropdown(equipmentOption);
    setEquipmentTypeIdDropdown({} as DropdownOption);
    setCapacityIdDropdown({} as DropdownOption);

    let eqtoTree = equipmentSubTree.find(
      (eqto) => eqto.id === equipmentOption.id
    );

    if (eqtoTree) {
      eqtoTree.types && setEquipmentTypeProps(eqtoTree.types);
      eqtoTree.capacities && setCapacitiesProps(eqtoTree.capacities);
    }
    setHasError((errors) => ({
      ...errors,
      hasErrorOnEquipment: "",
    }));
  }

  function handleSelectedCapacity(capacity: DropdownOption) {
    if (capacityIdDropdown && capacityIdDropdown.id === capacity.id) {
      return;
    }

    setCapacityIdDropdown(capacity);
  }

  function handleSelectedEquipmentType(equipmentType: DropdownOption) {
    if (
      equipmentTypeIdDropdown &&
      equipmentTypeIdDropdown.id === equipmentType.id
    ) {
      return;
    }

    setEquipmentTypeIdDropdown(equipmentType);
  }

  function EquipmentCreate() {
    let obj: EquipmentDTO = {
      categoryId: parseInt(categoryIdDropdown.id.toString()),
      equipmentId: parseInt(equipmentIdDropdown.id.toString()),
      equipmentTypeId:
        equipmentTypeIdDropdown && equipmentTypeIdDropdown.id
          ? parseInt(equipmentTypeIdDropdown.id.toString())
          : -1,
      capacityId: capacityIdDropdown.id
        ? parseInt(capacityIdDropdown.id.toString())
        : -1,
      brand: brand,
      model: model,
      tagEquipment: tagEquipment,
      componentName: componentName,
    };

    if (!equipmentTypeIdDropdown || obj.equipmentTypeId === -1) {
      delete obj.equipmentTypeId;
    }
    if (!capacityIdDropdown || obj.capacityId === -1) {
      delete obj.capacityId;
    }
    if (!brand || brand === "") {
      delete obj.brand;
    }
    if (!brand || brand === "") {
      delete obj.brand;
    }

    if (!model || model === "") {
      delete obj.model;
    }
    if (!componentName || componentName === "") {
      delete obj.componentName;
    }

    if (!tagEquipment || tagEquipment === "") {
      delete obj.tagEquipment;
    }

    return obj;
  }

  function handleErrorsValidate() {
    let errorValidate = false;
    if (!categoryIdDropdown || Object.keys(categoryIdDropdown).length < 1) {
      setHasError((errors) => ({
        ...errors,
        hasErrorOnCategory: "Categoria é obrigatório",
      }));
      errorValidate = true;
    }
    if (!equipmentIdDropdown || Object.keys(equipmentIdDropdown).length < 1) {
      setHasError((errors) => ({
        ...errors,
        hasErrorOnEquipment: "Equipamento é obrigatório",
      }));
      errorValidate = true;
    }
    if (isComponentName && componentName.trim().length < 1) {
      setHasError((errors) => ({
        ...errors,
        hasErrorOnComponentName: "Nome do componente é obrigatório",
      }));
      errorValidate = true;
    }
    if (!tagEquipment || tagEquipment.length < 9) {
      setHasError((errors) => ({
        ...errors,
        hasErrorOnTagEquipment:
          "Tag do equipamento é obrigatório e deve ter 9 caracteres",
      }));

      errorValidate = true;
    }
    return errorValidate;
  }

  async function handleSaveEquipment() {
    try {
      setLoadingButton(true);

      if (handleErrorsValidate()) {
        addToast({
          title: "Ops!!",
          description: "Preencha todos os campos obrigatórios!",
          type: "error",
        });
        return;
      }

      const aux = EquipmentCreate();

      await api.put(
        `/unities/${unityIdPMOC}/environment/${environment.id}/equipment/${equipment.id}`,
        aux
      );
      addToast({
        title: "Ok!!",
        description: "Equipamento editado com sucesso!",
        type: "success",
      });

      handleBackButton();
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        setHasError(errors);

        addToast({
          title: "Ops!!",
          description: "Preencha todos os campos obrigatórios!",
          type: "error",
        });
        return;
      }
      addToast({
        title: "Erro",
        description:
          axios.isAxiosError(err) && err.response?.data.error
            ? err.response.data.error
            : "Ocorreu um erro ao editar o equipamento.",
        type: "error",
      });
    } finally {
      setLoadingButton(false);
    }
  }

  function handleNewEquipmentType(text: string) {
    setNewEquipmentType(text);
  }

  async function handleSubmitTypeEqto() {
    if (!newEquipmentType) {
      addToast({
        title: "Ops",
        description: "Preencha com alguma informação antes de prosseguir",
        type: "error",
      });
      return;
    }

    try {
      setLoadingInputButton(true);
      const response = await api.post(
        `/services/equipment/${equipmentIdDropdown.id}/type`,
        {
          name: newEquipmentType,
        }
      );

      const { types } = response.data;

      setEquipmentTypeProps([...equipmentTypeProps, types[types.length - 1]]);

      setNewEquipmentType("");

      addToast({
        title: "Sucesso",
        description: "Tipo de equipamento cadastrado com sucesso!",
        type: "success",
      });
    } catch (err) {
      addToast({
        title: "Ops",
        description: "Ocorreu um erro ao cadastrar",
        type: "error",
      });
    } finally {
      setLoadingInputButton(false);
    }
  }

  function handleNewCapacity(text: string) {
    setNewCapacity(text);
  }

  async function handleSubmitCapacity() {
    if (!newCapacity) {
      addToast({
        title: "Ops",
        description: "Preencha com alguma informação antes de prosseguir",
        type: "error",
      });
      return;
    }

    try {
      setLoadingButton(true);
      const response = await api.post("services/capacities", {
        equipmentID: equipmentIdDropdown.id,
        name: newCapacity,
      });

      const capacityValue = response.data;

      setCapacitiesProps([...capacitiesProps, capacityValue]);
      setNewCapacity("");

      addToast({
        title: "Sucesso",
        description: "Capacidade cadastrada com sucesso!",
        type: "success",
      });
    } catch (err) {
      addToast({
        title: "Ops",
        description: "Ocorreu um erro ao cadastrar",
        type: "error",
      });
    } finally {
      setLoadingButton(false);
    }
  }

  function handleNewEquipment(text: string) {
    setNewEquipment(text);
  }

  async function handleSubmitEqto() {
    if (!newEquipment) {
      addToast({
        title: "Ops",
        description: "Preencha com alguma informação antes de prosseguir",
        type: "error",
      });
      return;
    }

    try {
      setLoadingButton(true);
      const response = await api.post("services/equipment", {
        categoryID: Number(categoryIdDropdown.id),
        name: newEquipment,
      });

      const { id, name } = response.data;

      setEquipmentSubTree([
        ...equipmentSubTree,
        {
          id,
          name,
          types: [],
          capacities: [],
          default: false,
        },
      ]);

      setEquipmentsData([...equipmentsData, { id, name, default: "false" }]);

      setNewEquipment("");

      addToast({
        title: "Sucesso",
        description: "Equipamento cadastrado com sucesso!",
        type: "success",
      });
    } catch (err) {
      addToast({
        title: "Ops",
        description: "Ocorreu um erro ao cadastrar",
        type: "error",
      });
    } finally {
      setLoadingButton(false);
    }
  }

  const handleWarningTypeEqt = () => {
    if (!equipmentIdDropdown.id) {
      addToast({
        title: "Atenção!",
        description: "Selecione um equipamento",
        type: "info",
      });
    }
  };

  const handleWarningEqto = () => {
    if (!categoryIdDropdown.id) {
      addToast({
        title: "Atenção!",
        description: "Selecione uma categoria",
        type: "info",
      });
    }
  };

  const handleWarningCapacity = () => {
    if (!equipmentIdDropdown.id) {
      addToast({
        title: "Atenção!",
        description: "Selecione um equipamento",
        type: "info",
      });
    }
  };

  async function HandleDeleteEqto(idEquipment: number) {
    try {
      await api.delete(
        `/client/${userIdPMOC}/unities/${unityIdPMOC}/environment/${environment.id}/equipment/${idEquipment}`
      );

      addToast({
        title: "Ok!!",
        description: "Equipamento inativado com sucesso!",
        type: "success",
      });

      if (nameFlow === "unity" && handleChooseEditModal) {
        return handleChooseEditModal("detailEnvironment");
      }
      handleChooseEnvironment && handleChooseEnvironment("detailEnvironment");
    } catch (error) {
      addToast({
        title: "Erro",
        description:
          axios.isAxiosError(error) && error.response?.data.error
            ? error.response.data.error
            : "Não foi possível inativar o equipamento.",
        type: "error",
      });
    }
  }

  return (
    <>
      {loadingInfo ? (
        <LoadingProfiz isVisible={loadingInfo} />
      ) : (
        <S.Container>
          <AlertModal
            isVisible={showAlertDelete}
            title="Deseja apagar?"
            description="Deseja realmente apagar esse item?"
            action="choose"
            handleConfirm={() => {
              setShowAlertDelete(false);
              HandleDeleteEqto(equipment.id);
            }}
            onCloseModal={() => setShowAlertDelete(false)}
          />

          <S.Top>
            <S.BackButton
              onClick={() => {
                handleBackButton();
              }}
            >
              <FiChevronLeft size={16} color={theme.colors.text} />
            </S.BackButton>

            <S.Title>Editar Equipamento</S.Title>
          </S.Top>

          <S.Wrapper>
            <Dropdown
              label="Categoria*"
              placeholder="Selecione uma categoria"
              options={categoryProps}
              categoryIdSelected={categoryIdDropdown.id}
              // eslint-disable-next-line react/jsx-no-bind
              onClickedValue={handleSelectedCategory}
              hasError={hasError.hasErrorOnCategory}
            />
          </S.Wrapper>

          <S.Wrapper>
            {categoryIdDropdown && categoryIdDropdown.id > 0 ? (
              <Dropdown
                label="Equipamento*"
                type="equipment"
                hasInput
                placeholder="Selecione um equipamento"
                options={equipmentsData}
                categoryIdSelected={equipmentIdDropdown.id}
                // eslint-disable-next-line react/jsx-no-bind
                onClickedValue={handleSelectedEquipment}
                hasError={hasError.hasErrorOnEquipment}
                moduleHashValue="equipment"
                actionView
              >
                <InputAddNewCategory
                  isLoadingButton={loadingInputButton}
                  value={newEquipment}
                  // eslint-disable-next-line react/jsx-no-bind
                  handleChangeNewCategory={handleNewEquipment}
                  // eslint-disable-next-line react/jsx-no-bind
                  handleSave={handleSubmitEqto}
                />
              </Dropdown>
            ) : (
              <DisabledDropDown
                label="Equipamento*"
                title="Selecione um equipamento"
                onClick={() => handleWarningEqto()}
                hasError={hasError.hasErrorOnEquipment}
              />
            )}
          </S.Wrapper>

          <S.Wrapper>
            <S.WrapperDualInput>
              <S.WrapperInputSmall>
                {equipmentIdDropdown && equipmentIdDropdown.id > 0 ? (
                  <Dropdown
                    label="Tipo"
                    placeholder="Tipo do equipamento"
                    hasInput
                    type="type"
                    options={equipmentTypeProps}
                    categoryIdSelected={equipmentTypeIdDropdown.id}
                    // eslint-disable-next-line react/jsx-no-bind
                    onClickedValue={handleSelectedEquipmentType}
                    clearDropDownItem
                    handleClear={() => {
                      handleSelectedEquipmentType({} as DropdownOption);
                    }}
                    moduleHashValue="equipment-type"
                    actionView
                  >
                    <InputAddNewCategory
                      isLoadingButton={loadingInputButton}
                      value={newEquipmentType}
                      // eslint-disable-next-line react/jsx-no-bind
                      handleChangeNewCategory={handleNewEquipmentType}
                      // eslint-disable-next-line react/jsx-no-bind
                      handleSave={handleSubmitTypeEqto}
                    />
                  </Dropdown>
                ) : (
                  <DisabledDropDown
                    label="Tipo"
                    title="Tipo de equipamento"
                    onClick={() => handleWarningTypeEqt()}
                  />
                )}
              </S.WrapperInputSmall>

              <S.WrapperInputSmall>
                {equipmentIdDropdown && equipmentIdDropdown.id > 0 ? (
                  <Dropdown
                    label="Capacidade"
                    hasInput
                    type="capacity"
                    placeholder="Capacidade do equipamento"
                    options={capacitiesProps}
                    categoryIdSelected={capacityIdDropdown.id}
                    // eslint-disable-next-line react/jsx-no-bind
                    onClickedValue={handleSelectedCapacity}
                    clearDropDownItem
                    handleClear={() => {
                      handleSelectedCapacity({} as DropdownOption);
                    }}
                    moduleHashValue="equipment-capacity"
                    actionView
                  >
                    <InputAddNewCategory
                      isLoadingButton={loadingButton}
                      value={newCapacity}
                      // eslint-disable-next-line react/jsx-no-bind
                      handleChangeNewCategory={handleNewCapacity}
                      // eslint-disable-next-line react/jsx-no-bind
                      handleSave={handleSubmitCapacity}
                    />
                  </Dropdown>
                ) : (
                  <DisabledDropDown
                    label="Capacidade"
                    title="Capacidade do equipamento"
                    onClick={() => handleWarningCapacity()}
                  />
                )}
              </S.WrapperInputSmall>
            </S.WrapperDualInput>
          </S.Wrapper>

          <S.Wrapper>
            <S.WrapperDualInput>
              <S.WrapperInputSmall>
                <Input
                  name="Marca"
                  placeholder="Ex.: Mídea"
                  value={brand}
                  onChange={(e) => setBrand(e.target.value.trimStart())}
                />
              </S.WrapperInputSmall>
              <S.WrapperInputSmall>
                <Input
                  name="Modelo"
                  placeholder="Ex.: Maxiflex Inverter"
                  value={model}
                  onChange={(e) => setModel(e.target.value.trimStart())}
                />
              </S.WrapperInputSmall>
            </S.WrapperDualInput>
          </S.Wrapper>

          <S.WrapperInput>
            <S.Title>Tags do equipamento</S.Title>
            <S.MessageTag>Inserir tags no equipamento*</S.MessageTag>
            {/* <S.WrapperTagButton>
                <S.ContainerTagButton>
                  <Button
                    typeButton={typeTagEquipment < 2 ? "default" : "disabled"}
                    onClick={() => {
                      setTypeTagEquipment(1);
                    }}
                  >
                  Automaticamente
                  </Button>
                </S.ContainerTagButton>
                <S.ContainerTagButton>
                  <Button
                    typeButton={typeTagEquipment > 1 ? "default" : "disabled"}
                    onClick={() => {
                      setTypeTagEquipment(2);
                    }}
                  >
                  Manualmente
                  </Button>
                  </S.ContainerTagButton>
              </S.WrapperTagButton> */}

            <Input
              isCheckedIcon
              maxLength={9}
              name="Definir uma tag com 9 caracteres"
              placeholder="Ex.: LEV-01001"
              value={tagEquipment}
              onChange={(e) => setTagEquipment(e.target.value.trim())}
              hasError={hasError.hasErrorOnTagEquipment}
              onFocusClearError={() =>
                setHasError({ ...hasError, hasErrorOnTagEquipment: "" })
              }
            />
          </S.WrapperInput>

          <S.WrapperInput>
            <S.Title>Componentes</S.Title>
            <S.WrapperDualInput>
              <S.SubTitle>Cadastrar componentes individualmente?</S.SubTitle>
              <ToogleButton
                isChecked={isComponentName}
                onChange={() => {
                  setIsComponentName(!isComponentName);
                }}
              />
            </S.WrapperDualInput>
            {isComponentName && (
              <S.Wrapper>
                <Input
                  name="Nome do componente*"
                  placeholder="Ex.: Condensadora"
                  value={componentName}
                  onChange={(e) => setComponentName(e.target.value.trimStart())}
                  hasError={hasError.hasErrorOnComponentName}
                  onFocusClearError={() =>
                    setHasError({ ...hasError, hasErrorOnComponentName: "" })
                  }
                />
              </S.Wrapper>
            )}
          </S.WrapperInput>

          {/* BOTÂO QRCODE */}
          {/*
            <S.WrapperInput>
                <Button typeButton="qrcode" >
                    <img src={QRCodeIcon} alt={"icone qrcode"} />
                    Gerar QR Code para o equipamento
                </Button>
            </S.WrapperInput> */}

          <S.WrapperInput marginTop={10}>
            <Button
              loading={loadingButton}
              disabled={loadingButton}
              typeButton="default"
              onClick={handleSaveEquipment}
            >
              Salvar alterações
            </Button>
          </S.WrapperInput>

          <S.WrapperInput>
            <ShowWhenHavePermission
              moduleHash="client-unity-equipment"
              actionHash="delete"
            >
              <Button
                typeButton="delete"
                onClick={() => {
                  setShowAlertDelete(true);
                }}
              >
                Deletar equipamento
              </Button>
            </ShowWhenHavePermission>
          </S.WrapperInput>
        </S.Container>
      )}
    </>
  );
}
